export const MODULES=Object.freeze({
    "ALL":"All",
    "COLABORADOR":"Colaboradores",
    "PERFILES_PUESTO":"PerfilesPuesto",
    "VACANTES":"Vacantes",
    "DOCUMENTOS":"Documentos",
    "SALARIES":"RecibosNomina",
    "TRAINING":"Training",
    "PERFIL_PUESTO":"PerfilPuesto",
    //Permisos aun en desuso
    "COLABORADOR_HERRAMIENTAS":"ColaboradorHerramientas",
    "PROMOTIONS":"Promotions",
    "DEFAULT":"Default",
    "UNIFORMES":"Uniformes",
    "VACACIONES":"Vacaciones",
    "CAJA_AHORRO":"CajaAhorro",
    "FONDO_FIJO":"FondoFijo",
    "PAGOS":"Pagos",
    "BAJAS":"Bajas",
    "CARGOS":"Cargos",
    "SOLICITUDES":"Solicitudes",
    "CUENTAS":"Cuentas",
    "FINANCIERAS":"Financieras",
    "CONTABILIDAD":"Contabilidad",
    "MANTENIMIENTO":"Mantenimiento",
    "CURSOS":"Cursos",
    "PRESTAMOS":"Prestamos",
})